import { InjectionToken } from '@angular/core';

import { AppEnv } from './app-config.models';

export const APP_ENV = new InjectionToken<AppEnv>('ireckonu.env');
